<template>
  <div>
    <div class="d-flex align-center mb-8">
      <div>
        <v-btn @click="$router.go(-1)" class="left-arrow" icon>
          <v-icon>mdi-arrow-top-left</v-icon>
        </v-btn>
      </div>
      <div class="ml-2">
        <span class="heading">Stock Research Reports</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        @click="uploadReportDialog"
        outlined
        class="text-none"
        color="primary"
        v-if="is_sebi_registered"
        >Upload</v-btn
      >
      <v-btn
        v-else
        outlined
        class="text-none"
        color="primary"
        @click="$router.push({ name: 'Downloads' })"
        >Downloaded Stock Reports</v-btn
      >
    </div>
    <StockReportList />
    <UploadReportDialog />
  </div>
</template>
<script>
import commonFunctions from "@/common/commonFunctions";
import apiUrl from "@/common/apiUrl";
import newAxios from "@/api/newAxios";
import StockReportList from "@/components/Trending/ResearchReport/StockReportList.vue";
import UploadReportDialog from "@/components/Trending/ResearchReport/UploadReportDialog";
export default {
  name: "ResearchReport",
  data() {
    return {
      is_sebi_registered: false,
    };
  },
  components: {
    StockReportList,
    UploadReportDialog,
  },
  computed: {},
  mounted() {
    this.getUserDetail();
  },
  methods: {
    uploadReportDialog() {
      this.$store.commit("ResearchReport/toggleUploadReportModal", {
        show: true,
      });
    },
    getUserDetail() {
      const onSuccess = (res) => {
        this.is_sebi_registered =
          res.data.user_detail.profile.is_sebi_registered;
      };
      const onFailure = () => {};
      let params = {};
      params["id"] = commonFunctions.getUserId();
      newAxios("get", apiUrl.ADMIN_PANEL_APIS, {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
  },
};
</script>
<style scoped>
.heading {
  color: hsl(0deg 0% 0% / 87%);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.left-arrow {
  transform: rotate(-45deg);
}
</style>
